import React, { useState, useEffect } from 'react';
import './App.css';
import ProgressBar from './components/ProgressBar';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ButtonConfirm from './components/ButtonConfirm';
import TextButton from './components/TextButton';
import SeletorCustom from './components/SeletorCustom';
import TextFieldCustom from './components/TextFieldCustom';
import MaskCep from './components/MaskCep';
import { CircularProgress, MenuItem, Stack, TextField } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QrCodeComponent from './components/QrCode';
import { ValidatePix, CreateOrderPix, PaymentCardCredit } from './scripts/Payment';
import { GetAllData } from './scripts/GetAllData';
import { STATE } from './scripts/State';
import CountrySelect from './components/SelectCountry';
import { PHONE_CODES } from './contries/phones_codes';
import WhatsAppButton from './components/WhatsappButton';
import { ApplyCupom } from './scripts/cupom';


let ORDER_ID = '';

const App = () => {
  const [passoAtual, setPassoAtual] = useState(1);
  const [errorField, setErrorField] = useState(0);
  const [errorDescription, setErrorDescription] = useState({ description: '' });
  const [validadeCampos, setValidadeCampos] = useState({ endereco: false, usuario: false, cartao: false });
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState({});
  const [valores, setValores] = useState([{ installment: 1, valueTotal: 0, value: 0, addInformation: '' }]);
  const [valueSelected, setValue] = useState({ installment: 1, valueTotal: 0, value: 0, addInformation: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [errorPayment, setErrorPayment] = useState({ description: '' });
  const [methodPayment, setMethodPayment] = useState(0);
  const [methodsAvailable, setMethodsAvailable] = useState([1, 2]);
  const [descriptionSnackbar, setDescriptionSnackbar] = useState({ description: '' });

  const [pix, setPixCode] = React.useState({ code: '' });
  let countErrorPix = 0;

  const fieldNenhum = 0;
  const fieldName = 1;
  const fieldEmail = 2;
  const fieldRua = 3;
  const fieldCidade = 4;
  const fieldCep = 5;
  const fieldNomeCartao = 6;
  const fieldNumeroCartao = 7;
  const fieldValidadeCartao = 8;
  const fieldCvv = 9;
  const fieldBairro = 10;
  const fieldNumero = 11;
  const fieldDocument = 12;
  const fieldPhone = 13;
  const fieldEstado = 14;
  const fieldCupom = 15;

  // Estados para armazenar os valores dos campos dos formulários
  // const [endereco, setEndereco] = useState({ cep: '89120-000', cidade: 'Timbo', rua: 'Rua bahamas', bairro: 'Das nações', numero: '345', estado: 'SC', country: 'BR' });
  // const [usuario, setUsuario] = useState({ nome: 'João Vitor Magaroti', email: 'joaovitortur1@gmail.com', document: '48500337842', phone: '+055' });
  // const [cartao, setCartao] = useState({ nome_cartao: 'joao vitor magaroti', numero_cartao: '5502 0971 0227 0855', validade_cartao: '01/32', cvv: '172', installments: 1 });
  // const [cupom, setCupom] = useState({ cupom: '' });

  const [endereco, setEndereco] = useState({ cep: '', cidade: '', rua: '', bairro: '', numero: '', estado: '', country: 'BR' });
  const [usuario, setUsuario] = useState({ nome: '', email: '', document: '', phone: '', area_code_phone: '', country_code_phone: '', phone_number: '' });
  const [cartao, setCartao] = useState({ nome_cartao: '', numero_cartao: '', validade_cartao: '', cvv: '', installments: 1 });
  const [cupom, setCupom] = useState({ cupom: '' });

  const [product, setProduct] = useState({ name: '', amount: 0, description: '', quantity: 0, priceReal: '', code: '' });
  const [isErrorCep, setIsErrorCep] = useState(false);
  const [phoneMask, setPhoneMask] = useState('+55 (99) 99999-9999');
  const COUNTRYBR = 'BR';
  let IsBR = endereco.country == COUNTRYBR;
  const [maskNumberCard, setMaskNumberCard] = useState('9999 9999 9999 9999');


  cartao.method = methodPayment
  cartao.installments = valueSelected.installment
  cartao.totalValue = valueSelected.valueTotal

  let result = {
    "endereco": endereco,
    "usuario": usuario,
    "cartao": cartao,
    "product": product,
  }


  let errorPaymentDefault = IsBR ? "Erro ao processar pagamento, tente novamente" : "Error processing payment, try again"
  let errorApplyCupom = IsBR ? "Cupom Invalido" : "Cupom Invalid";

  function _setOrderId(id) {
    ORDER_ID = id;
  }

  function PaymentCardCreditLocal() {
    setIsLoadingPayment(true);
    PaymentCardCredit(result,
      (message) => {
        // Usa a mensagem do servidor diretamente
        const errorMessage = message || errorPaymentDefault;

        setErrorPayment({ description: errorMessage });
        openSnackbar();
        setIsLoadingPayment(false);
      },
      (status) => {
        onStatus(status);
      },
    );
  }

  function onStatus(status, closed) {
    
    switch (status.toLowerCase()) {
      case "received":
        setErrorPayment({ description: "" });
        setPassoAtual(passoAtual + 1);
        setIsLoadingPayment(false);
        setIsLoading(false);
        break;
      case "pending":
        console.log('pending');
        break;
      case "waiting":
        console.log('waiting');
        break;
      default:
        if (closed) {
          setCountAddErrorPix();
          _setErrorPayment({ description: "Seu Pix expirou. Estamos enviando outro código Pix para você" });
          setMethodsAvailableLocal(true, false, data)
          setIsLoading(false);
          setIsLoadingPayment(false);
          break;
        } else {
          _setErrorPayment({ description: errorPaymentDefault });
          setIsLoading(false);
          setIsLoadingPayment(false);
          break;
        }
    }
  }

  useEffect(() => {
    console.log('pix', pix.code);
  }, [pix]);

  useEffect(() => {
    const pollingFunction = () => {
      handlePayment();
    };

    const intervalId = setInterval(pollingFunction, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [passoAtual === 3]);

  useEffect(() => {
    atualizarBarraProgresso();
  }, [passoAtual]);

  useEffect(() => {
    setIsLoading(true);
    GetData()
  }, []);

  function CreateOrderPixLocal() {
    CreateOrderPix(result,
      (message) => {
        // Usa a mensagem do servidor diretamente
        const errorMessage = message || errorPaymentDefault;

        setCountAddErrorPix();
        setMethodsAvailableLocal(true, false, data);
        _setErrorPayment({ description: errorMessage });
        setIsLoading(false);
      },
      (status, closed, id, pixCode) => {
        if (id != "" && id != undefined && id != null && (ORDER_ID == "" || ORDER_ID == undefined || ORDER_ID == null)) {
          setMethodPayment(2);
          setPixCode({ code: pixCode });
          _setOrderId(id);
        }

        onStatus(status, closed);
      });
  }

  function ValidatePixLocal() {
    setIsLoading(false);
    ValidatePix(ORDER_ID,
      (message) => {
        setIsLoading(false);

        // Usa a mensagem do servidor diretamente
        const errorMessage = message || errorPaymentDefault;

        _setErrorPayment({ description: errorMessage });
      },
      (status, closed) => {
        onStatus(status, closed);
      });
  }

  function FindCep(cep) {
    if (endereco.country != COUNTRYBR) {
      setIsErrorCep(true);
      return;
    }

    let formatCep = cep.replace(/_/g, '').replace('-', '');

    if (formatCep.length < 8) {
      return;
    } else {
      fetch(`https://viacep.com.br/ws/${formatCep}/json/`)
        .then(async (result) => {
          let body = await result.json();
          let city = body.localidade;
          let uf = body.uf;
          let bairro = body.bairro;
          let rua = body.logradouro;
          let erro = body.erro;
          let country = 'BR';

          if (erro) {
            setIsErrorCep(true);
            _setError({ description: IsBR ? "CEP não encontrado" : "CEP not found" });
            return;
          }

          setEndereco({ ...endereco, cidade: city || endereco.cidade, estado: uf || endereco.estado, cep: cep || endereco.cep, country: country || endereco.country, bairro: bairro || endereco.bairro, rua: rua || endereco.rua });
          setIsErrorCep(false);
        }).catch((error) => {
          setIsErrorCep(true);
          _setError({ description: IsBR ? "A API de CEP está temporariamente indisponível." : "The ZIP API is temporarily unavailable." });
        });
    }
  }

  function _setError({ description }) {
    setErrorDescription({ description: description });
    openSnackbar();

    setTimeout(() => {
      setErrorDescription({ description: "" });
    }, 4000);
  }

  function _setDescriptionSnackbar({ description }) {
    setDescriptionSnackbar({ description: description });
    openSnackbar();

    setTimeout(() => {
      setDescriptionSnackbar({ description: "" });
    }, 4000);
  }

  function _setErrorPayment({ description }) {
    setErrorPayment({ description: description });
    openSnackbar();

    setTimeout(() => {
      setErrorPayment({ description: "" });
    }, 4000);
  }

  function handlePayment() {
    if (countErrorPix == 3) {
      _setErrorPayment({ description: "Pix indísponível no momento." });
      setCountAddErrorPix();
      setIsLoading(false);
    } else if (countErrorPix > 3) {
    } else if (passoAtual === 3 && ORDER_ID != "") {
      setIsLoading(false);
      if (ORDER_ID != "" || ORDER_ID != undefined || ORDER_ID != null) {
        ValidatePixLocal();
      }

    }
  }

  function setCountAddErrorPix() {
    countErrorPix = countErrorPix + 1;
  }

  async function GetData() {
    const parameters = new URLSearchParams(window.location.search);

    let id = parameters.get('id');

    GetAllData(id).then((data) => {
      setData(data);
      setValores(data.product.installments);
      setValue(data.product.installments.length > 0 ? data.product.installments[0] : 0);
      setMethodsAvailableLocal(false, false, data);

      data.product.priceReal = " " + (data.product.amount / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      data.product.code = `${data.product.id}`

      setProduct(data.product);
      setIsLoading(false);

    }).catch((error) => {
      setIsLoading(false);
    });
  }

  function setMethodsAvailableLocal(enabledCard, enabledPix, dataLocal) {
    const pixEnabled = dataLocal.pix.enabled || data.pix.enabled;
    const cardCreditEnabled = dataLocal.cardCredit.enabled || data.cardCredit.enabled;

    if (enabledCard && enabledPix) {
      setMethodPayment(1);
      setMethodsAvailable([1, 2]);
    } else if (enabledPix) {
      setMethodPayment(2);
      setMethodsAvailable([2]);
    } else if (enabledCard) {
      setMethodPayment(1);
      setMethodsAvailable([1]);
    } else if (pixEnabled && cardCreditEnabled) {
      setMethodPayment(1);
      setMethodsAvailable([1, 2]);
    } else if (pixEnabled) {
      setMethodPayment(2);
      setMethodsAvailable([2]);
    } else if (cardCreditEnabled) {
      setMethodPayment(1);
      setMethodsAvailable([1]);
    }
  }

  const proximoPasso = () => {
    FindCep(endereco.cep || '');
    _setMethodPaymentsByCountry(endereco.country);
    if (passoAtual <= 3) {

      if (passoAtual === 3) {
        PaymentCardCreditLocal();
        return;
      }
      
      const resultValidate = validateFieldsAll();

      if (passoAtual === 1 && resultValidate) {
        setPassoAtual(passoAtual + 1);
      }

      if (passoAtual === 2) {
        FindCep(endereco.cep);

        const resultValidate = validateFieldsAll();

        if (resultValidate) {
          setPassoAtual(passoAtual + 1);
        }
      }

      
    }
  };

  const passoAnterior = () => {
    if (passoAtual > 1) {
      setPassoAtual(passoAtual - 1);
    }
  };


  const openSnackbar = () => {
    setOpen(true);
    setIsLoading(false);

    setTimeout(() => {
      if (errorDescription.description.length > 0) {
        setErrorPayment({ description: "" });
      }

      if (descriptionSnackbar.description.length > 0) {
        setDescriptionSnackbar({ description: "" });
      }

      if (errorPayment.description.length > 0) {
        setErrorPayment({ description: "" });
      }
      setOpen(false);
    }, 4000);
  }

  function atualizarBarraProgresso() {
    const etapas = document.querySelectorAll(".etapa");
    etapas.forEach((etapa, index) => {
      if (index < passoAtual - 1) {
        etapa.style.backgroundColor = "#20222D"; // Cor da etapa concluída
      } else if (index === passoAtual - 1) {
        etapa.style.backgroundColor = "#FFC107"; // Cor da etapa atual
      } else {
        etapa.style.backgroundColor = "#ddd"; // Cor da etapa não concluída
      }

      if (passoAtual == 2) {
        etapa.style.borderRadius = "0px 0px 0px 0px";
      }
    });
  };

  function validateFieldsAll() {
    const messageUsuario = validarCamposUsuario();

    if (messageUsuario != null && passoAtual === 1) {
      _setError({ description: messageUsuario });
      return false;
    }

    const messageEndereco = validarCamposEndereco();

    if (messageEndereco != null && passoAtual === 2) {
      _setError({ description: messageEndereco });
      return false;
    }

    const messageCartao = validarCamposCartao();

    if (messageCartao != null && passoAtual === 3) {
      _setError({ description: messageCartao });
      return false;
    }

    return true;
  }

  function validarCamposEndereco() {
    const { rua, cidade, cep, bairro, numero } = endereco;

    if (IsBR ? (!cep || !cep.match(/[0-9]{5}-[0-9]{3}/)) : (!cep || cep.length < 5)) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldCep);
      return IsBR ? "O CEP deve ser válido" : "The ZIP must be valid"
    } else if (!bairro || bairro.length <= 1) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldBairro);
      return IsBR ? "O bairro deve ser válido" : "The neighborhood must be valid"
    } else if (!cidade || cidade.length <= 1) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldCidade);
      return IsBR ? "A cidade deve ser válida" : "The city must be valid"
    } else if (!IsBR && endereco.estado.length <= 1) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldEstado);
      return IsBR ? "O estado deve ser válido" : "The state must be valid"
    } else if (!rua || rua.length <= 1) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldRua);
      return IsBR ? "A rua deve ser válida" : "The street must be valid"
    } else if (!numero || numero.length <= 0) {
      setValidadeCampos({ ...validadeCampos, endereco: false });
      setErrorField(fieldNumero);
      return IsBR ? "O número deve ser válido" : "The number must be valid"
    } else {
      setValidadeCampos({ ...validadeCampos, endereco: true });
      setErrorField(fieldNenhum);
      return null;
    }
  };

  function validarCamposUsuario() {
    const { nome, email, document, phone } = usuario;

    if (nome.length <= 3) {
      setValidadeCampos({ ...validadeCampos, usuario: false });
      setErrorField(fieldName);
      return IsBR ? "O nome deve ter mais de 3 caracteres" : "The name must have more than 3 characters"
    } else if (!isValidEmail(email)) {
      setValidadeCampos({ ...validadeCampos, usuario: false });
      setErrorField(fieldEmail);
      return IsBR ? "O email deve ser válido" : "The email must be valid"
    } else if (!document || document.length < 11) {
      setValidadeCampos({ ...validadeCampos, usuario: false });
      setErrorField(fieldDocument);
      return IsBR ? "O CPF deve ser válido" : "The Document must be valid"
    } else if (phone.length < 12 || phone.length > 20) {
      setValidadeCampos({ ...validadeCampos, usuario: false });
      setErrorField(fieldPhone);
      return IsBR ? "O telefone deve ser válido" : "The phone must be valid"
    } else {
      setValidadeCampos({ ...validadeCampos, usuario: true });
      setErrorField(fieldNenhum);
      return null;
    }
  };

  function validarCamposCartao() {
    const { nome_cartao, numero_cartao, validade_cartao, cvv } = cartao;

    if (nome_cartao.length <= 3) {
      setValidadeCampos({ ...validadeCampos, cartao: false });
      setErrorField(fieldNomeCartao);
      return IsBR ? "O nome no cartão deve ter mais de 3 caracteres" : "The name on the card must have more than 3 characters"
    } else if (numero_cartao.length < 18) {
      setValidadeCampos({ ...validadeCampos, cartao: false });
      setErrorField(fieldNumeroCartao);
      return IsBR ? "O número do cartão deve ser válido" : "The card number must be valid"
    } else if (!validade_cartao.match(/(0[1-9]|1[0-2])\/?([0-9]{2})$/)) {
      setValidadeCampos({ ...validadeCampos, cartao: false });
      setErrorField(fieldValidadeCartao);
      return IsBR ? "A validade do cartão deve ser válida" : "The card expiration must be valid"
    } else if (!cvv.match(/^[0-9]{3,4}$/)) {
      setValidadeCampos({ ...validadeCampos, cartao: false });
      setErrorField(fieldCvv);
      return IsBR ? "O CVV deve ter 3 ou 4 dígitos" : "The CVV must have 3 or 4 digits"
    } else {
      setValidadeCampos({ ...validadeCampos, cartao: true });
      setErrorField(fieldNenhum);
      return null;
    }
  };


  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  }

  function generatedPix() {
    setIsLoading(true);
    CreateOrderPixLocal();
  }

  function _getCountryCode(countryCodeE) {
    let phoneCountryCode = "+55"; // Inicializa o código do país como Brasil
    for (const countryCode in PHONE_CODES) {

      if (countryCodeE.includes(countryCode)) {
        phoneCountryCode = PHONE_CODES[countryCode];

        const phoneCountryCodeFormat = phoneCountryCode.replace(/\d/g, '9');
        if (phoneCountryCode == "+55") {
          const phoneMaskFormat = `${phoneCountryCodeFormat} (99) 99999-9999`;
          setPhoneMask(phoneMaskFormat);
        } else {
          const phoneMaskFormat = `${phoneCountryCodeFormat} (999) 9999999`;
          setPhoneMask(phoneMaskFormat);
        }
        break;
      }
    }

    return phoneCountryCode;
  }

  function _setMethodPaymentsByCountry(country) {
    setIsLoading(true);
    //Remover o pix para outros países
    if (country != COUNTRYBR) {
      setMethodsAvailable([1]);
      setIsLoading(false);
    } else {
      setMethodsAvailableLocal(false, false, data);
      setIsLoading(false);
    }
  }

  function _setApplyCupom(text) { 
    const data = {
      cupom: text,
      nome: usuario.nome,
      email: usuario.email,
      valorCompra: product.amount
    };

    ApplyCupom(data, 
      (message) => {
        if (!message) {
          message = errorApplyCupom
        } else if (message.includes("{") && message.includes("}")) {
          message = errorApplyCupom
        }

        setErrorPayment({ description: errorApplyCupom });
        openSnackbar();
      },
      (e, data) => {
        setErrorDescription({ description: ''});
        setErrorField({ description: ''});
        setErrorPayment({ description: ''});

        setDescriptionSnackbar({ description: IsBR ? "Cupom Aplicado!" : "Cupom Applied!"});
        openSnackbar();

        let valorFinal = data.valorFinal; // Valor final já com o desconto aplicado
        let priceReal = " " + (valorFinal / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        // Gerar uma nova lista de parcelas aplicando o desconto
        const installments = product.installments.map(installment => {
          const novoValorTotal = (installment.valueTotal * valorFinal) / product.amount;
          const novoValorParcela = novoValorTotal / installment.installment;

          return {
              ...installment,
              valueTotal: novoValorTotal,
              value: novoValorParcela,
              priceFormatted: " " + (novoValorParcela / 100).toLocaleString('pt-BR', { 
                  style: 'currency', 
                  currency: 'BRL' 
              })
          };
        });

        setProduct({
          ...product,
          amount: valorFinal,
          priceReal: priceReal,
          installments: installments
        });

        setValores(installments);
        setValue(installments.length > 0 ? installments[0] : 0);
      }
    );
  }


  function isValidEmail(email) {
    // Verifica se o email tem @, um domínio e não ultrapassa 100 caracteres
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 100;
  }

  return (
    <div className="App">
      <WhatsAppButton>

      </WhatsAppButton>
      <Stack alignItems={'center'}>
        <img src='https://firebasestorage.googleapis.com/v0/b/radioteraquiz-1b949.appspot.com/o/loading.png?alt=media&token=ea087379-5f29-4dfc-8133-d90fb94648d8'  height={200} ></img>
      </Stack>
      <div className="container">
        <Stack>
          {
            _showWidget({
              show: passoAtual !== 4,
              widget: <Stack>
                <p style={{ fontSize: 20, fontWeight: '800', textAlign: 'center', fontFamily: 'Raleway', marginTop: 0 }}>{data.enabled == false && !isLoading ? "Produto índisponivel" : IsBR ? "Finalize sua compra" : "Finish your purchase"}</p>
                <ProgressBar passoAtual={passoAtual} />
              </Stack>
            })
          }
          {
            _showWidget({
              show: isLoading,
              widget: _loading(),
            })
          }
          {
            _showWidget({
              show: !isLoading,
              widget: <Stack>
                {
                  _showWidget({
                    show: isLoading,
                    widget: _loading()
                  })
                }
                {
                  _showWidget({
                    show: data.enabled == true && !isLoading,
                    widget: <div>
                      <div className="formulario">
                        {
                          _showWidget({
                            show: passoAtual === 4,
                            widget: <Stack alignItems={'center'}>
                              <CheckCircleIcon color='success' sx={{ fontSize: 80, color: 'success' }} />
                            </Stack>
                          })
                        }
                        {/* Formulário de usuário */}
                        {
                          _showWidget({
                            show: passoAtual === 1,
                            widget: <div>
                              <p style={{ fontSize: 18, fontWeight: '700', textAlign: 'center', fontFamily: 'Raleway' }}>{IsBR ? "Preencha as informações do usuário:" : "Fill in the user information:"}</p>
                              <p style={{ fontSize: 13, fontWeight: '500', textAlign: 'center', fontFamily: 'Raleway' }}>{IsBR ? "Se voce for membro teraquiz, preencha o mesmo email cadastrado no teraquiz" : "If you are a teraquiz member, fill in the same email registered in teraquiz"}</p>

                              <CountrySelect value={endereco.country} onChange={(e) => {
                                setEndereco({ ...endereco, country: e });
                                const phoneCountryCode = _getCountryCode(e);
                                _setMethodPaymentsByCountry(e);

                                setUsuario({ ...usuario, phone: phoneCountryCode });

                                setErrorField(fieldNenhum);
                              }} />
                              <TextFieldCustom label={IsBR ? "Nome" : "Name"} type={""} errorText={errorField == fieldName ? errorDescription.description : ""} value={usuario.nome} onChange={(e) => {
                                setUsuario({ ...usuario, nome: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              <TextFieldCustom label={"Email"} type={"email"} errorText={errorField == fieldEmail ? errorDescription.description : ""} value={usuario.email} onChange={(e) => {
                                setUsuario({ ...usuario, email: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              <MaskCep label={"CPF"} type={""} errorText={errorField == fieldDocument ? errorDescription.description : ""} mask={"999.999.999-99"} value={usuario.document} onChange={(e) => {
                                let document = e.target.value.replace(/\D/g, '');

                                setUsuario({ ...usuario, document: document });
                                setErrorField(fieldNenhum);
                              }} />
                              <MaskCep label={IsBR ? "Telefone" : "Phone Number"} type={""} errorText={errorField == fieldPhone ? errorDescription.description : ""} mask={phoneMask} value={usuario.phone} onChange={(e) => {
                                setUsuario({ ...usuario, phone: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              {
                                _showWidget({
                                  show: data.cupom && data.cupom.enabled,
                                  widget: <TextFieldCustom label={"Cupom"} type={""} errorText={errorField == fieldCupom ? errorDescription.description : ""} value={cupom.cupom} onChange={(e) => {
                                    setCupom({ cupom: e.target.value });
                                    _setApplyCupom(e.target.value);
                                    setErrorField(fieldNenhum);
                                  }} />
                                })
                              }

                              {/* Descrição do produto */}
                              {
                                product.description && (
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, color: '#000', fontFamily: 'Raleway', margin: '16px 8px 8px 8px' }}>
                                    <p style={{ margin: 0, textAlign: 'left' }}>{product.description}</p>
                                  </div>
                                )
                              }
                              {/* Botões de Ação */}
                              <ButtonConfirm onClick={proximoPasso} text={IsBR ? "Próximo" : "Next"} />
                            </div>
                          })
                        }
                        {/* Formulário de endereço */}
                        {
                          _showWidget({
                            show: passoAtual === 2,
                            widget: <div>
                              <p style={{ fontSize: 15, fontWeight: '500', textAlign: 'center', fontFamily: 'Raleway' }}>Preencha as informações do endereço:</p>
                              {
                                _showWidget({
                                  show: IsBR,
                                  widget: <MaskCep label={"CEP"} type={""} errorText={errorField == fieldCep ? errorDescription.description : ""} mask={"99999-999"} value={endereco.cep} onChange={(e) => {
                                    setEndereco({ ...endereco, cep: e.target.value });
                                    setErrorField(fieldNenhum);
                                    let cep = e.target.value;
                                    FindCep(cep);
                                  }} />
                                })
                              }
                              {
                                _showWidget({
                                  show: !IsBR,
                                  widget: <TextFieldCustom label={"ZIP-CODE"} type={""} errorText={errorField == fieldCep ? errorDescription.description : ""} value={endereco.cep} onChange={(e) => {
                                    setEndereco({ ...endereco, cep: e.target.value });
                                    setErrorField(fieldNenhum);
                                  }} />
                                })
                              }
                              <TextFieldCustom label={IsBR ? "Bairro" : "Neighborhood"} type={""} errorText={errorField == fieldBairro ? errorDescription.description : ""} value={endereco.bairro} onChange={(e) => {
                                setEndereco({ ...endereco, bairro: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              {
                                _showWidget({
                                  show: IsBR, widget: (
                                    <div>
                                      <TextFieldCustom label={IsBR ? "Cidade" : "City"} type={""} errorText={errorField == fieldCidade ? errorDescription.description : ""} value={endereco.cidade} onChange={(e) => {
                                        setEndereco({ ...endereco, cidade: e.target.value });
                                        setErrorField(fieldNenhum);
                                      }} />
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        select
                                        label="Estado"
                                        value={endereco.estado}
                                        defaultValue={STATE[0]}
                                        margin='dense'
                                        inputProps={{ readOnly: false }}
                                        onChange={(e) => {
                                          setEndereco({ ...endereco, estado: e.target.value });
                                          setErrorField(fieldNenhum);
                                        }}
                                      >
                                        {STATE.map((option) => (
                                          <MenuItem key={option} value={option}>
                                            {option}
                                          </MenuItem>
                                        ))}
                                      </TextField>
                                    </div>
                                  )
                                })
                              }
                              {
                                _showWidget({
                                  show: !IsBR, widget: (
                                    <div>
                                      <TextFieldCustom label={IsBR ? "Cidade" : "City"} type={""} errorText={errorField == fieldCidade ? errorDescription.description : ""} value={endereco.cidade} onChange={(e) => {
                                        setEndereco({ ...endereco, cidade: e.target.value });
                                        setErrorField(fieldNenhum);
                                      }} />
                                      <TextFieldCustom label={IsBR ? "Estado" : "State"} type={""} errorText={errorField == fieldEstado ? errorDescription.description : ""} value={endereco.estado} onChange={(e) => {
                                        setEndereco({ ...endereco, estado: e.target.value });
                                        setErrorField(fieldNenhum);
                                      }} />
                                    </div>
                                  )
                                })
                              }
                              <TextFieldCustom label={IsBR ? "Rua" : "Street"} type={""} errorText={errorField == fieldRua ? errorDescription.description : ""} value={endereco.rua} onChange={(e) => {
                                setEndereco({ ...endereco, rua: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              <TextFieldCustom label={IsBR ? "Número" : "Number"} type={""} errorText={errorField == fieldNumero ? errorDescription.description : ""} value={endereco.numero} onChange={(e) => {
                                setEndereco({ ...endereco, numero: e.target.value });
                                setErrorField(fieldNenhum);
                              }} />
                              {/* Botões de Ação */}
                              <ButtonConfirm onClick={proximoPasso} text={IsBR ? "Próximo" : "Next"} />
                              <TextButton onClick={passoAnterior} text={IsBR ? "Voltar" : "Back"} />
                            </div>
                          })
                        }
                        {/* Formulário de cartão */}
                        {
                          _showWidget({
                            show: passoAtual == 3,
                            widget: <div>
                              <p style={{ fontSize: 15, fontWeight: '500', textAlign: 'center', fontFamily: 'Raleway' }}>Preencha as informações para pagamento:</p>
                              {_getMethodPayments(setMethodPayment, methodPayment, methodsAvailable)}
                              {/* Cartão de Crédito */}
                              {
                                methodPayment == 1 && (
                                  <div>
                                    <TextFieldCustom label={IsBR ? "Nome no Cartão" : "Name on the Card"} type={""} errorText={errorField == fieldNomeCartao ? errorDescription.description : ""} value={cartao.nome_cartao} onChange={(e) => {
                                      setCartao({ ...cartao, nome_cartao: e.target.value });
                                      setErrorField(fieldNenhum);
                                    }} />
                                    <MaskCep label={IsBR ? "Número do Cartão" : "Card Number"} type={""} errorText={errorField == fieldNumeroCartao ? errorDescription.description : ""} mask={maskNumberCard} value={cartao.numero_cartao} onChange={(e) => {
                                      setCartao({ ...cartao, numero_cartao: e.target.value });

                                      let value = e.target.value.replace(/\D/g, '');
                                      
                                      if (value.length <= 15){
                                        setMaskNumberCard('9999 999 999 999999');
                                      } else {
                                        setMaskNumberCard('9999 9999 9999 9999');
                                      }

                                      setErrorField(fieldNenhum);
                                    }} />
                                    <MaskCep label={IsBR ? "Validade" : "Expiration"} type={""} errorText={errorField == fieldValidadeCartao ? errorDescription.description : ""} mask={"99/99"} value={cartao.validade_cartao} onChange={(e) => {
                                      setCartao({ ...cartao, validade_cartao: e.target.value });
                                      setErrorField(fieldNenhum);
                                    }} />
                                    <TextFieldCustom label={"CVV"} type={""} errorText={errorField == fieldCvv ? errorDescription.description : ""} mask={"999"} value={cartao.cvv} onChange={(e) => {
                                      let cvv = e.target.value.replace(/\D/g, '');

                                      setCartao({ ...cartao, cvv: cvv });
                                      setErrorField(fieldNenhum);
                                    }} />
                                    <SeletorCustom options={valores} transformValues={(opcao, _) => `${opcao.installment}x de ` + (opcao.value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).toString() + " " + opcao.addInformation} value={valueSelected} label={"Parcelas"} onChange={(e) => {
                                      setValue(e.target.value);
                                    }} />
                                    {
                                      isLoadingPayment && (
                                        _loading()
                                      )
                                    }
                                    {/* Botões de pagamento */}
                                    {
                                      !isLoadingPayment && (
                                        <div>
                                          <ButtonConfirm onClick={proximoPasso} text={IsBR ? "Pagar" : "Pay"} />
                                          <TextButton onClick={passoAnterior} text={IsBR ? "Voltar" : "Back"} />
                                        </div>
                                      )
                                    }
                                  </div>
                                )}
                              {/* Pix */}
                              {
                                methodPayment == 2 && isLoading && IsBR && (
                                  _loading()
                                )
                              }
                              {
                                methodPayment == 2 && pix.code.length == 0 && !isLoading && IsBR && (
                                  <div>
                                    <p style={{ fontSize: 15, fontWeight: '600', textAlign: 'center', fontFamily: 'Raleway' }}>Para gerar o pix, clique no botão abaixo:</p>
                                    <ButtonConfirm onClick={generatedPix} text={"Gerar Pix"} />
                                    <TextButton onClick={passoAnterior} text={"Voltar"} />
                                  </div>
                                )
                              }
                              {
                                methodPayment == 2 && pix.code.length > 0 && IsBR && (
                                  <QrCodeComponent value={pix.code} />
                                )
                              }
                            </div>
                          })
                        }
                        
                        {/* Pagamento feito com sucesso */}
                        {
                          _showWidget({
                            show: passoAtual === 4,
                            widget: <Stack>
                              <p style={{ marginTop: 8, marginBottom: 0, fontWeight: '700', fontSize: 21, textAlign: 'center', fontFamily: 'Raleway' }}>{IsBR ? "Pagamento efetuado com sucesso!" : "Payment made successfully!"}</p>
                              <p style={{ fontSize: 14, textAlign: 'center', marginBottom: 8, marginTop: 8, fontFamily: 'Raleway' }}>{IsBR ? "Obrigado por comprar conosco!" : "Thank you for buying with us!"}</p>
                              <ButtonConfirm onClick={() => {
                                setPassoAtual(1);
                                setEndereco({ rua: '', cidade: '', cep: '' });
                                setUsuario({ nome: '', email: '' });
                                setCartao({ nome_cartao: '', numero_cartao: '', validade_cartao: '', cvv: '' });
                                setValue(valores.length > 0 ? valores[0] : 0);
                                window.location.reload();
                              }} text={IsBR ? "Nova Compra" : "New Purchase"} />
                            </Stack>
                          })
                        }
                      </div>
                      {/* Snackbar de erros */}
                      {
                        _snackbar({
                          open: open,
                          errorDescription: errorDescription.description || errorPayment.description,
                          descriptionSnackbar: descriptionSnackbar.description,
                          handleClose: handleClose,
                        })
                      }
                    </div>
                  })
                }
              </Stack>
            })
          }
        </Stack>
      </div>
    </div>
  );
};



function _showWidget({ show, widget }) {
  return show ? widget : null;
}

function _snackbar({ open, errorDescription, descriptionSnackbar, handleClose }) {
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert
        onClose={handleClose}
        severity={descriptionSnackbar != "" ? "success" : "error"}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {errorDescription || descriptionSnackbar}
      </Alert>
    </Snackbar>
  )
}

function _loading() {
  return (
    <Stack alignItems={'center'}>
      <CircularProgress color='success' />
    </Stack>
  )
}

function _getMethodPayments(setMethodPayment, methodPayment, methodsAvailable) {
  return (
    <Stack className='method-payment' direction={'row'} justifyContent={'center'} marginBottom={'12px'}  >
      {methodsAvailable.includes(1) && (
        <button style={{ backgroundColor: methodPayment == 1 ? '#FFC107' : null }} onClick={() => {
          setMethodPayment(1);
        }}>
          <p style={{ color: methodPayment == 1 ? null : '#fff' }}>Cartão</p>
        </button>
      )}

      {methodsAvailable.includes(2) && (
        <button style={{ backgroundColor: methodPayment == 2 ? '#FFC107' : null }} onClick={() => {
          setMethodPayment(2);
        }}>
          <p style={{ color: methodPayment == 2 ? null : '#fff' }} >Pix</p>
        </button>
      )}
    </Stack>
  )
}

export default App;
